import React from "react";
import { Form, Image } from "react-bootstrap";
import { Controller, useFormContext } from "react-hook-form";
import { BidFormInput, Facility } from "../types/type";

export const initialData_plan4 = [
    {
        start_time: '',
        end_time: '',
        usage_1: 0,
        usage_2: 0,
    },
    {
        start_time: '',
        end_time: '',
        usage_1: 0,
        usage_2: 0,
    },
    {
        start_time: '',
        end_time: '',
        usage_1: 0,
        usage_2: 0,
    },
    {
        start_time: '',
        end_time: '',
        usage_1: 0,
        usage_2: 0,
    },
    {
        start_time: '',
        end_time: '',
        usage_1: 0,
        usage_2: 0,
    }
];

const Plan4: React.FC<{ facility: Facility, confirm: boolean }> = ({ facility, confirm }) => {
    const { control, watch, setValue } = useFormContext<BidFormInput>();
    const is_custom = watch(`conditions.${facility.id}.is_custom`);
    const custom_check_1 = watch(`conditions.${facility.id}.custom_check_1`);
    const custom_check_2 = watch(`conditions.${facility.id}.custom_check_2`);
    const custom_check_3 = watch(`conditions.${facility.id}.custom_check_3`);

    let visible = false;
    if (is_custom) {
        visible = (!custom_check_1 && !custom_check_2 && custom_check_3);
    } else {
        visible = (facility.contract_type == "SEASON_TIME_ZONE" || facility.contract_type == "LOW_LOAD_TIME");
    }
    const record = 3;
    const items = Array.from({ length: record }, (_, i) => (
        <tr key={i}>

            {
                <>
                    <td className="w-m-140 py-2">
                        <div className="input-group">
                            <Controller
                                name={`conditions.${facility.id}.usage.${i}.start_time`}
                                control={control}
                                rules={{
                                    required: { value: true, message: "必須入力" },
                                    validate: (value) => {
                                        if (value !== null || "") {
                                            return true;
                                        }
                                        return "入力してください";
                                    },
                                }}
                                render={({ field }) => (
                                    <input className="form-control mb-3 rounded-0 name-required  text-right"
                                        {...field}
                                        placeholder=""
                                        disabled={confirm}
                                    />
                                )}
                            />
                            <span className="text-md"> ～ </span>
                            <Controller
                                name={`conditions.${facility.id}.usage.${i}.end_time`}
                                control={control}
                                rules={{
                                    required: { value: true, message: "必須入力" },
                                    validate: (value) => {
                                        if (value !== null || "") {
                                            return true;
                                        }
                                        return "入力してください";
                                    },
                                }}
                                render={({ field }) => (
                                    <input className="form-control mb-3 rounded-0 name-required  text-right"
                                        {...field}
                                        placeholder=""
                                        disabled={confirm}
                                    />
                                )}
                            />
                        </div>
                    </td>
                    <td className="w-m-140 py-2">
                        <div className="input-group">
                            <Controller
                                name={`conditions.${facility.id}.usage.${i}.usage_1`}
                                control={control}
                                rules={{
                                    required: { value: true, message: "必須入力" },
                                    validate: (value) => {
                                        if (value !== null || "") {
                                            return true;
                                        }
                                        return "数値を入力してください";
                                    },
                                }}
                                render={({ field }) => (
                                    <input className="form-control mb-3 rounded-0 name-required  text-right"
                                        {...field}
                                        placeholder=""
                                        disabled={confirm}
                                        type="number"
                                    />
                                )}
                            />
                            <div className="input-group-append">
                                <Image className="img img-fluid ml-3" width="15" src="assets/images/bidding-condition/kwh.svg" />
                            </div>
                        </div>
                    </td>
                    <td className="w-m-140 py-2" >
                        <div className="input-group">
                            <Controller
                                name={`conditions.${facility.id}.usage.${i}.usage_2`}
                                control={control}
                                rules={{
                                    required: { value: true, message: "必須入力" },
                                    validate: (value) => {
                                        if (value !== null || "") {
                                            return true;
                                        }
                                        return "数値を入力してください";
                                    },
                                }}
                                render={({ field }) => (
                                    <input className="form-control mb-3 rounded-0 name-required  text-right"
                                        {...field}
                                        placeholder=""
                                        disabled={confirm}
                                        type="number"
                                    />
                                )}
                            />
                            <div className="input-group-append">
                                <Image className="img img-fluid ml-3" width="15" src="assets/images/bidding-condition/kwh.svg" />
                            </div>
                        </div>
                    </td>
                </>
            }

        </tr>
    ));

    return (
        <table className={`table table-bordered table-vertical-align-middle text-center plan ${visible ? '' : 'd-none'}`} >
            <thead>
                <tr>
                    <td scope="col" className="bg-ass-table fw-400 py-1">時間帯</td>
                    <td scope="col" className="bg-ass-table fw-400 py-1">{facility.contract_type == "LOW_LOAD_TIME" ? '単価' : '夏季'}</td>
                    <td scope="col" className={`bg-ass-table fw-400 py-1 ${facility.contract_type == "LOW_LOAD_TIME" ? "d-none" : ""}`}>その他季</td>
                </tr>
            </thead>
            <tbody className="bg-white">
                {items}
                {/* <tr>
                    <td className="w-m-140 py-2">
                        <div className="input-group">
                            <span className="border px-4 py-2 mr-1">2020/01/01</span> ～ <span className="border px-4 py-2 ml-1">2021/01/01</span>
                            <input type="hidden" />
                            <input type="hidden" />
                            <input type="text" className="form-control mx-3 rounded-0" placeholder="" aria-label="" aria-describedby="basic-addon1" />
                            <span className="text-md"> ～ </span>
                            <input type="text" className="form-control ml-3 rounded-0" placeholder="" aria-label="" aria-describedby="basic-addon1" />
                        </div>
                    </td>
                    <td className="w-m-140 py-3">
                        <div className="text-right fw-400">
                            <div className="d-inline-block">46234</div>
                            <Image className="img img-fluid ml-3 d-inline-block" width="15" src="assets/images/bidding-condition/kwh.svg" />
                        </div>
                        <input type="hidden" />
                    </td>

                    <td className="w-m-140 py-3">
                        <div className="text-right fw-400">
                            <div className="d-inline-block">6353</div>
                            <Image className="img img-fluid ml-3 d-inline-block" width="15" src="assets/images/bidding-condition/kwh.svg" />
                        </div>
                        <input type="hidden" />
                    </td>

                </tr> */}
            </tbody>
        </table>
    )
}

export default Plan4;